import Bluebird from 'bluebird'
import jsPDF from '../../../jspdf'
import axios from 'axios'
import { includes } from 'lodash'
import { getCachedFont, setCachedFont } from '../../font_cache'

const addedFontLocations = new Set()
const pendingFontLoads = new Map()

export function preloadFonts(fonts) {
  return Bluebird.each(fonts, (font) => {
    if (!font.location || addedFontLocations.has(font.location)) return

    // If another render is already loading this font, wait for that promise
    if (pendingFontLoads.has(font.location)) {
      return pendingFontLoads.get(font.location)
    }

    const load = getCachedFont(font.location)
      .then((fontBase64) => {
        if (fontBase64) return fontBase64
        return urlToBase64(font.location)
          .then(fontBase64 => setCachedFont(font.location, fontBase64).then(() => fontBase64))
      })
      .then((fontBase64) => {
        pushFontIntoJsPDF(font.family, font.variant, fontBase64)
        addedFontLocations.add(font.location)
      })
      .finally(() => {
        pendingFontLoads.delete(font.location)
      })

    pendingFontLoads.set(font.location, load)
    return load
  })
}

// Black magic I tell you.
function urlToBase64(url) {
  // strip the scheme off the url so it matches whatever we are
  url = url.replace(/^http(s?):/, "")
  return Bluebird.try(() => axios.get(url, { responseType: 'blob' })
    .then((response) => response.data)

    .then((blob) => new Promise((resolve) => {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        // Remove the DataURL preamble, like:
        // data:font/ttf;base64,
        // data:application/x-font-ttf;base64,
        const indexAfterPreamble = (reader.result.indexOf("base64,")+7),
          base64Font = reader.result.substr(indexAfterPreamble)
        resolve(base64Font)
      }
    }))
  )
}

export function pushFontIntoJsPDF(fontName, fontVariant, fontBase64) {
  var callAddFont = function () {
    const fontNameNoWhitespace = fontName.replace(/ /g, ""),
      fontIndexName = `${fontNameNoWhitespace}-${fontVariant}.ttf`
    this.addFileToVFS(fontIndexName, fontBase64)
    this.addFont(fontIndexName, fontNameNoWhitespace, fontVariant)
  }

  jsPDF.API.events.push(['addFonts', callAddFont])
}
